import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { sendPasswordRestored } from '../../context/users/UserActions'
import { useUserContext } from '../../context/users/UserContext'
import { FaSpinner, FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa'
import '../../styles/RestorePassword.css'

// eslint-disable-next-line
export default function (props) {
  const { setAlert } = useUserContext()
  const navigate = useNavigate()
  const params = useParams()
  const [isLoading, setIsLoading] = useState(true)
  const [isSuccess, setIsSuccess] = useState(false)
  const [isError, setIsError] = useState(false)
  const [message, setMessage] = useState('')
  const [email, setEmail] = useState('')

  window.scrollTo({
    top: 0,
    behavior: 'auto',
  })

  const fetchData = async () => {
    const getRestoredPass = async () => {
      try {
        const response = await sendPasswordRestored(params.userToken)
        if(typeof response === 'string') {
          if (response.includes('Hemos enviado tu nueva contraseña al correo:')) {
            const extractedEmail = response.replace('Hemos enviado tu nueva contraseña al correo: ', '')
            setEmail(extractedEmail)
            setMessage(`Contraseña actualizada exitosamente. Hemos enviado un correo a ${extractedEmail} con tu nueva contraseña.`)
            setIsSuccess(true)
            setAlert({
              message: `Contraseña actualizada exitosamente. Hemos enviado un correo a ${extractedEmail} con tu nueva contraseña.`,
              msgType: 'success'
            })
          } else {
            setMessage(response)
            setIsError(true)
            setAlert({
              message: response,
              msgType: 'warning'
            })
          }
        } else {
          setMessage(response.message || 'Error al procesar la solicitud')
          setIsError(true)
          setAlert({
            message: response.message || 'Error al procesar la solicitud',
            msgType: 'warning'
          })
        }
      } catch (error) {
        setMessage('Error en el servidor. Por favor intenta más tarde.')
        setIsError(true)
        setAlert({
          message: 'Error en el servidor. Por favor intenta más tarde.',
          msgType: 'error'
        })
      } finally {
        setIsLoading(false)
      }
    }

    getRestoredPass()
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <div className="restore-password-container">
      <div className="restore-password-layout">
        {/* Sección izquierda - Imagen */}
        <div className="restore-password-image-section">
          <div className="restore-password-image-container">
            <img 
              src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" 
              alt="Recuperación de contraseña" 
              className="restore-password-hero-image" 
            />
            <div className="restore-password-image-overlay">
              <div className="restore-password-overlay-content">
                <div className="restore-password-logo-container-overlay">
                  <div className="restore-password-develemos-logo-custom">
                    <div className="restore-password-logo-graphic">
                      <div className="restore-password-logo-curve"></div>
                      <div className="restore-password-logo-dot"></div>
                    </div>
                    <div className="restore-password-logo-text">Develemos</div>
                    <div className="restore-password-logo-tagline">FIND OUR TRUTHS</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Sección derecha - Contenido */}
        <div className="restore-password-content-section">
          <div className="restore-password-card">
            <h1 className="restore-password-title">Recuperación de Contraseña</h1>
            
            <div className="restore-password-content">
              {isLoading && (
                <div className="restore-password-loading">
                  <FaSpinner className="restore-password-loading-spinner" />
                  <p className="restore-password-loading-text">Procesando tu solicitud...</p>
                </div>
              )}

              {isSuccess && !isLoading && (
                <div className="restore-password-success">
                  <h3 className="restore-password-success-title">
                    <FaCheckCircle className="restore-password-success-icon" />
                    ¡Contraseña Restaurada!
                  </h3>
                  <p className="restore-password-success-message">
                    Hemos enviado tu nueva contraseña al correo:
                  </p>
                  <p className="restore-password-success-email">{email}</p>
                  <p className="restore-password-success-instructions">
                    Revisa tu bandeja de entrada y utiliza la nueva contraseña para ingresar a la plataforma.
                  </p>
                </div>
              )}

              {isError && !isLoading && (
                <div className="restore-password-error">
                  <h3 className="restore-password-error-title">
                    <FaExclamationTriangle className="restore-password-error-icon" />
                    Error en la Recuperación
                  </h3>
                  <p className="restore-password-error-message">{message}</p>
                </div>
              )}

              <div className="restore-password-actions">
                <button 
                  onClick={() => navigate('/')} 
                  className="restore-password-button"
                >
                  Volver al Login
                </button>
              </div>
            </div>

            <p className="restore-password-terms-text">
              Si tienes problemas para acceder, contacta a{' '}
              <a 
                href="mailto:soporte@develemos.com" 
                target="_blank"
                rel="noopener noreferrer"
              >
                soporte@develemos.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
